export default __webpack_public_path__ + "static/media/Sortby.865ef793.svg";